import {Card, CardContent, Tooltip, Typography, Paper, Box, Stack, Skeleton} from '@mui/material'
import { useTheme } from '@mui/material/styles';

export interface CardProps {
    dateRange: string;
    title: string;
    mainContent?: React.ReactNode 
    topMetric ? : string;
    loading?: boolean;
};

export default function CiCard({ title, dateRange, mainContent, topMetric, loading = false }: CardProps) {
  return (
      <Card sx={{ marginBottom: "20px", paddingBottom: "0px", width: '100%'}}> 
        <Box sx={{padding:"16px 24px"}}>  
        <Stack direction="row" sx={{flex: "1 0", justifyContent:"space-between"}}>
          {loading ? (
            <Skeleton variant="text" width={150} height={24} />
          ) : (
            <Typography title={title} sx={{fontSize: "16px", fontWeight:400}}>
              {title}
            </Typography>
          )}
          {loading ? (
            <Skeleton variant="text" width={80} height={28} />
          ) : (
            <Typography fontSize="20px" fontWeight="600">
              {topMetric}
            </Typography>
          )}
          </Stack>
            <Box sx={{marginY:"16px"}}>
              {loading ? (
                <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 1 }} />
              ) : (
                mainContent
              )}
            </Box>
        </Box>
        <Paper
        sx={{
          backgroundColor: "background.neutral", 
          borderRadius:"0 0 10px 10px",
          padding: "6px 12px",
          gap:"16px",
          position: "absolute",
          bottom: "0px",
          width: "100%",
          marginTop: "16px",
        }} 
        >
          {loading ? (
            <Skeleton variant="text" width={100} height={13} />
          ) : (
            <Typography
              sx={{
                fontSize: "13px",
                lineHeight: "13px",
                color: "#919EAB",
              }}
            >
              Last {dateRange}
            </Typography>
          )}
        </Paper>
      </Card>

  )}

